import { Box, Typography } from '@mui/material';
import { useChildTokens } from './useChildTokens';
import { elapsedFraction, formatTime, TimerViewProps, TIMER_SURFACE } from './timerView';

/**
 * Ringen — barnvyns ursprungliga (och förvalda) tidsvisare.
 *
 * Oförändrat utseende: conic-gradient där accentfärgen växer medsols allt eftersom
 * tiden går, med mm:ss och etikett i mitten. Ren renderare: tiden kommer som prop,
 * ingen egen setInterval (se timerView.ts).
 */
const TimerRing = ({
  time,
  totalSeconds,
  label,
  color,
  onToggle,
  showDigits = true,
}: TimerViewProps) => {
  const tokens = useChildTokens();
  const degrees = elapsedFraction(time, totalSeconds) * 360;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2.5 }}>
      <Box
        component="button"
        type="button"
        data-testid="timer-ring"
        onClick={onToggle}
        aria-label={label}
        sx={{
          width: TIMER_SURFACE,
          height: TIMER_SURFACE,
          borderRadius: '50%',
          display: 'grid',
          placeItems: 'center',
          position: 'relative',
          border: 'none',
          cursor: onToggle ? 'pointer' : 'default',
          background: `conic-gradient(${color} ${degrees}deg, ${tokens.border} ${degrees}deg)`,
          transition: 'background 1s linear',
          '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
        }}
      >
        <Box
          sx={{
            width: 150,
            height: 150,
            borderRadius: '50%',
            bgcolor: tokens.card,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {showDigits && (
            <Typography sx={{ fontSize: '2rem', fontWeight: 900, color: tokens.text }}>
              {formatTime(time)}
            </Typography>
          )}
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: tokens.textSoft }}>
            {label}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TimerRing;
